<!-- eslint-disable --> 
<template>
  <div class="app">
    <div class="app__inner">
      <div class="app__top-bar">
        <div class="app__top-bar__brand">
          <router-link
            exact
            to="/"
          >WiFi Connector</router-link>
        </div>
        <div class="app__top-bar__nav">
          <div class="menu">
            <router-link
              :class="(item.isActive) ? 'active' : ''"
              :key="index"
              :to="item.path"
              class="menu__menu-item"
              exact
              v-for="(item, index) in navItems"
            >
              <span class="menu-item__icon">
                <icon
                  :icon="item.meta.sideBarIcon"
                  v-if="item.meta.sideBarIcon"
                />
              </span>
              <span class="menu__itme__label">{{ item.meta.displayName }}</span>
            </router-link>
          </div>
        </div>
        <div class="app__top-bar__controls">
          <div
            @click="signOut()"
            class="btn btn-generic-tertiary"
          >Sign Out</div>
        </div>
      </div>
      <div class="app__main">
        <router-view></router-view>
      </div>
      <div class="app__footer"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'dashboard',
  data() {
    return {
      toggleSidebar: false,
    };
  },
  computed: {
    navItems() {
      return this.$router.options.routes[1].children
        .filter(item => item.meta && item.meta.showInNav);
    },
  },
  components: {},
  methods: {
    getIcon: icon => import(`vue-feather-icons/icons/${icon}`),
    tryFeedback() {
      this.$toast('success', 'Example body content', 'Example title');
      this.$notify('error', 'Error', 'Whoops');
    },
    signOut() {
      this.$store.dispatch('logout').then(() => {
        this.$store.dispatch('clearLandingPageState');
      }).then(() => {
        this.$router.push('/login');
      })
        .catch((err) => {
          this.$notify('error', err, 'Whoops');
        });
    },
  },
};
</script>

<style lang="scss">
$dashboard_top-bar_bg: #f0f4f7;
$dashboard_brand_bg: #15396b;
$dashboard_side-bar_bg: #00254a;

.app {
  background: linear-gradient(
    to bottom,
    $dashboard_side-bar_bg 0%,
    $dashboard_side-bar_bg 33%,
    $dashboard_side-bar_bg 33%,
    $dashboard_top-bar_bg 33%,
    $dashboard_top-bar_bg 100%
  );
  height: 100%;
}

.app__inner {
  max-width: 960px;
  margin: 0 auto;
}

.app__top-bar {
  display: grid;
  grid-template-columns: 200px auto 200px;
  height: 94px;
  align-items: center;
  border-bottom: 0.5px solid #405778;
}

.app__top-bar__brand {
  text-align: left;
  a {
    color: #fff;
    &:hover {
      color: #fff;
      text-decoration: none;
    }
  }
}

.app__top-bar__nav {
  .menu {
    display: flex;

    &__menu-item {
      flex: 1;
      color: #fff;
      opacity: 0.7;
      text-align: center;

      .menu-item__icon {
        margin-right: 8px;

        svg {
          position: relative;
          top: -2px;
          height: 16px;
          width: 16px;
        }
      }

      .menu__itme__label {
        line-height: 1rem;
        font-size: 14px;
      }

      &.is-active {
        font-weight: 700;
        text-decoration: none;
        opacity: 1;

        .menu-item__icon {
          svg {
            stroke: #da3e7c;
          }
        }
      }

      &:hover {
        color: #fff;
        text-decoration: none;
        background: darken($dashboard_side-bar_bg, 1%);
      }
    }
  }
}

.app__top-bar__controls {
  text-align: right;
}

.app__main {
  padding-top: 30px;
}

.feather {
  vertical-align: middle;
}
</style>
